import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { ScreenService } from 'core/services';
import { DissentRequestedPresenter } from './presenter';

export const DissentRequested: React.VFC = () => {
  const { t } = useTranslation();
  return (
    <>
      <Helmet>
        <title>
          {ScreenService.getDocumentTitle(t('ui.pages.DissentRequested.title'))}
        </title>
      </Helmet>
      <DissentRequestedPresenter />
    </>
  );
};
